import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionSectionProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function AccordionSection({
  title,
  icon,
  children,
  defaultOpen = false
}: AccordionSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border-b border-gray-100 last:border-0" data-id="element-24">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between py-4 px-1 hover:bg-gray-50/50 transition-colors" data-id="element-25">
        <div className="flex items-center gap-3" data-id="element-26">
          {icon && <span className="text-gray-400" data-id="element-27">{icon}</span>}
          <span className="font-semibold text-gray-900" data-id="element-28">{title}</span>
        </div>
        <ChevronDown size={20} className={`text-gray-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-29" />
      </button>
      <div className={`
          overflow-hidden transition-all duration-300 ease-in-out
          ${isOpen ? 'max-h-[500px] opacity-100 mb-4' : 'max-h-0 opacity-0'}
        `} data-id="element-30">
        {children}
      </div>
    </div>;
}